import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom align="center">
        プライバシーポリシー
      </Typography>
      <Typography variant="subtitle1" align="center" gutterBottom>
        制定日：2025年4月17日
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>第1条（取得する個人情報）</Typography>
        <Typography paragraph>
          当社は、以下の情報を取得する場合があります。
          氏名、メールアドレス、電話番号、職業。
          また、当社が運営する専用WEBサイトにおいても、上記情報を取得する場合があります。
        </Typography>

        <Typography variant="h6" gutterBottom>第2条（個人情報の利用目的）</Typography>
        <Typography paragraph>
          取得した個人情報は、各種お問い合わせ対応、サービス案内、マーケティング調査・分析、
          本人確認、職業斡旋のための協力会社への提供、その他付随業務に利用します。
        </Typography>

        <Typography variant="h6" gutterBottom>第3条（未成年者の個人情報の取扱い）</Typography>
        <Typography paragraph>
          未成年者が個人情報を提供する場合、学生である旨を明示し、
          保護者の同意を得た上で行うものとします。
        </Typography>

        <Typography variant="h6" gutterBottom>第4条（クッキー（Cookie）及び類似技術の利用）</Typography>
        <Typography paragraph>
          当社ウェブサイトでは、利便性向上及びサービス向上を目的として、
          クッキー（Cookie）その他の類似技術を使用する場合があります。
        </Typography>

        <Typography variant="h6" gutterBottom>第5条（個人情報の第三者提供）</Typography>
        <Typography paragraph>
          当社は、本人の同意、法令に基づく場合、職業斡旋に関連する協力会社への提供を除き、
          第三者に個人情報を提供することはありません。
        </Typography>

        <Typography variant="h6" gutterBottom>第6条（個人情報の管理）</Typography>
        <Typography paragraph>
          当社は、漏洩、滅失、毀損等の防止のため、適切な安全管理措置を講じます。
        </Typography>

        <Typography variant="h6" gutterBottom>第7条（プライバシーポリシーの変更）</Typography>
        <Typography paragraph>
          本ポリシーは、法令改正、事業内容変更等に応じ、予告なく変更されることがあります。
          変更後は当社ウェブサイトへの掲載をもって効力を生じます。
        </Typography>

        <Typography variant="h6" gutterBottom>第8条（お問い合わせ窓口）</Typography>
        <Typography paragraph>
          本ポリシーに関するお問い合わせは、以下のメールアドレスまでご連絡ください。<br />
          E-mail：recruit1@cross-zeal.com
        </Typography>

        <Typography variant="h6" gutterBottom>第9条（準拠法及び管轄裁判所）</Typography>
        <Typography paragraph>
          本ポリシーに関する準拠法は日本法とし、関連する一切の紛争については
          東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
